import AdminHotelAmenities from './admin-hotel-amenities-component';

import './admin-hotel-amenities.scss';

const MODULE_NAME = 'App.admin.hotel-view.amenities';
const module = angular
    .module(MODULE_NAME, [])
    .directive(AdminHotelAmenities.DIRECTIVE_NAME, AdminHotelAmenities);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-amenities/admin-hotel-amenities-module.js